var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"children_container"},[_c('back-header',{attrs:{"title":"新增孩子"}}),_c('child-detail',{attrs:{"is-edit":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }